import { Box, Stack, Td } from '@chakra-ui/react';
import { AppLink, CurrencyLabel } from 'features';
import { useMemo } from 'react';
import { PaginatedTable } from '../components/PaginatedTable';
import { CommitmentType } from 'api';
import { Commitment } from 'api/bindings/Commitment';

export interface CommitmentViewEntityLinkProps {
  commitment: Commitment | undefined;
}
export const CommitmentViewEntityLink = (
  props: CommitmentViewEntityLinkProps
) => {
  const { commitment } = props;
  let linkTemplate = '';

  if (!commitment) return <></>;

  switch (commitment.commitmentTypeId) {
    case CommitmentType.PurchaseOrder:
      linkTemplate = `/app/purchase-orders/${commitment.commitmentId}/details`;
      break;
    case CommitmentType.WorkOrder:
      linkTemplate = `/app/work-orders/${commitment.commitmentId}/details`;
      break;
  }

  return <AppLink to={linkTemplate}>{commitment.name}</AppLink>;
};
export interface AfeCommittedLineItemsSectionProps {
  assignedCommitments: Commitment[] | undefined;
}

const commitmentAliasMap = {
  [CommitmentType.PurchaseOrder]: 'Purchase Order',
  [CommitmentType.WorkOrder]: 'Work Order',
};

export const AfeCommittedLineItemsSection = (
  props: AfeCommittedLineItemsSectionProps
) => {
  const { assignedCommitments = [] } = props;
  const augmentedAssignedCommitments = useMemo(() => {
    return assignedCommitments.map((c) => ({
      ...c,
      alias: commitmentAliasMap[c.commitmentTypeId],
    }));
  }, [assignedCommitments]);

  return (
    <Box>
      <Stack>
        <PaginatedTable
          items={augmentedAssignedCommitments}
          columns={[
            {
              component: 'Type',
              sortKey: 'alias',
            },
            {
              component: 'Commitment',
              sortKey: 'name',
            },
            {
              component: 'Pending',
              sortKey: 'pending',
              isNumeric: true,
            },
            {
              component: 'Total',
              sortKey: 'total',
              isNumeric: true,
            },
          ]}
        >
          {(c) => (
            <>
              <Td>{c.alias}</Td>
              <Td>
                <CommitmentViewEntityLink commitment={c} />
              </Td>
              <Td>
                <CurrencyLabel value={c.pending} />
              </Td>
              <Td>
                <CurrencyLabel value={c.total} />
              </Td>
            </>
          )}
        </PaginatedTable>
      </Stack>
    </Box>
  );
};
